/**
 * VANI – Shopify Product Helpers
 * Lightweight utilities loaded on product pages.
 * The primary product logic lives inline in main-product.liquid.
 * This file provides supplementary features:
 *   - Product recommendations (custom element)
 *   - Recently viewed tracking
 * ------------------------------------------------------------------
 */
(function () {
  'use strict';

  /* ─── Product Recommendations Custom Element ─── */
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() {
        var url = this.dataset.url;
        if (!url) return;

        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var recs = doc.querySelector('product-recommendations');
            if (recs && recs.innerHTML.trim().length) {
              this.innerHTML = recs.innerHTML;
            }
          }.bind(this))
          .catch(function () {});
      }
    });
  }

  /* ─── Recently Viewed (stores last 8 product handles) ─── */
  function trackRecentlyViewed() {
    var handle = document.querySelector('[data-product-handle]');
    if (!handle) return;

    var productHandle = handle.getAttribute('data-product-handle');
    if (!productHandle) return;

    var KEY = 'vani_recently_viewed';
    var MAX = 8;

    try {
      var stored = JSON.parse(localStorage.getItem(KEY) || '[]');
      stored = stored.filter(function (h) { return h !== productHandle; });
      stored.unshift(productHandle);
      if (stored.length > MAX) stored = stored.slice(0, MAX);
      localStorage.setItem(KEY, JSON.stringify(stored));
    } catch (e) {
      // localStorage unavailable
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackRecentlyViewed);
  } else {
    trackRecentlyViewed();
  }
})();
